import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { UpdateFormWithdrawalRequest } from "../../../../Transfer/models/transfer.model";
import { updateWithdrawalRequestService } from "../services/withdrawalRequest.service";
import { Button } from "primereact/button";
import { ToastControlBackendModel } from "../../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  idWithdrawalRequest: number;
  getAllWithdrawalRequestData: () => Promise<void>;
  setDialogEditWithdrawalRequest: () => void;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

function FormEditWitdrawalRequest({
  idWithdrawalRequest,
  getAllWithdrawalRequestData,
  setDialogEditWithdrawalRequest,
  setMessageBackend,
}: Props): JSX.Element {
  const [responseWithdrawalRequest, setResponseWithdrawalRequest] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dateToday = new Date().toISOString().split("T")[0];
      const dataForUpdate: UpdateFormWithdrawalRequest = {
        idWithdrawalRequest,
        responseWithdrawalRequest,
        dateResponse: dateToday,
      };

      const response = await updateWithdrawalRequestService(dataForUpdate);

      if (response) {
        setDialogEditWithdrawalRequest(); 
        await getAllWithdrawalRequestData();   
        setMessageBackend({
          severityValue: "success",
          detailValue: "Respuesta registrada con éxito",
          lifeValue: 3000,
          validateShowMessage: true,
        });
      }
    } catch (error) {
      setMessageBackend({
        severityValue: "error",
        detailValue: "Error al registrar respuesta",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (responseWithdrawalRequest.trim().length > 2) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [responseWithdrawalRequest]);

  return (
    <form className="flex flex-column gap-3 pt-2" onSubmit={onSubmit}>
      <div className="w-full">
        <InputText
          className="w-full"
          type="text"
          placeholder="Escribe tu respuesta aquí..."
          value={responseWithdrawalRequest}
          onChange={(e) => setResponseWithdrawalRequest(e.target.value)}
        />
      </div>
      <Button
        className="text-white w-full"
        label="Enviar respuesta"
        type="submit"
        disabled={loading}
      />
    </form>
  );
}

export default FormEditWitdrawalRequest;